import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SocialShareTagsProps {
  title: string;
  description: string;
  ogImage: string;
  canonicalUrl: string;
  ogType?: 'website' | 'article';
  siteName?: string;
  twitterHandle?: string;
  author?: string;
  publishedTime?: string;
  modifiedTime?: string;
}

const SocialShareTags: React.FC<SocialShareTagsProps> = ({
  title,
  description,
  ogImage,
  canonicalUrl,
  ogType = 'website',
  siteName = 'Global Therapy Connect',
  twitterHandle = '@globaltherapy',
  author,
  publishedTime,
  modifiedTime
}) => {
  return (
    <Helmet>
      {/* Open Graph Meta Tags */}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:alt" content={title} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="en_US" />
      
      {/* Additional Open Graph for Articles */}
      {ogType === 'article' && author && (
        <meta property="article:author" content={author} />
      )}
      
      {ogType === 'article' && publishedTime && (
        <meta property="article:published_time" content={publishedTime} />
      )}
      
      {ogType === 'article' && modifiedTime && (
        <meta property="article:modified_time" content={modifiedTime} />
      )}
      
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={twitterHandle} />
      <meta name="twitter:creator" content={twitterHandle} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:image:alt" content={title} />
      
      {/* Additional Social Media Meta Tags */}
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:type" content="image/png" />
      
      {/* Pinterest */}
      <meta name="pinterest-rich-pin" content="true" />
    </Helmet>
  );
};

export default SocialShareTags;